__turbopack_context__.v({
  "app-container": "DigitalReturnApp-module-scss-module__2Dxgsq__app-container",
  "app-container-iframe": "DigitalReturnApp-module-scss-module__2Dxgsq__app-container-iframe",
  "autologin-loading-spinner": "DigitalReturnApp-module-scss-module__2Dxgsq__autologin-loading-spinner",
});
